
export function deletarCamposParaSalvarCliente (pedido) {
  delete pedido.grupo
  delete pedido.id_grupo
  delete pedido.id_tipo_venda
}
